import React from 'react';
const ShowClimateFootprintInKg = ({ co2ePerKg, size, unit_id }) => {
  // Conversion function
  const convertToKgOrLiter = (size, unit_id) => {
    if (!size || !unit_id) return 0; // Handle missing values

    switch (unit_id) {
      case 2: // KGM (Kilograms)
        return size; // Already in kg
      case 3: // GRM (Grams)
        return size / 1000; // Convert grams to kg
      case 4: // MGM (Milligrams)
        return size / 1000000; // Convert mg to kg
      case 6: // LTR (Liters)
        return size; // Already in liters
      case 5: // MLT (Milliliters)
        return size / 1000; // Convert ml to liters
      case 11: // DLT (Deciliters)
        return size / 10; // Convert dl to liters
      case 1: // H87 (styck or piece)
        return size; // Assume each piece is equivalent to the size directly
      default:
        return 0; // Unsupported unit_id
    }
  };

  try {
    // Convert size to kg or liters
    const convertedSize = convertToKgOrLiter(size, unit_id);

    // Calculate total CO2e
    const co2eTotal = convertedSize ? (convertedSize * co2ePerKg)?.toFixed(2) : "N/A";

    return (
      <div className="flex justify-center items-center bg-white rounded-2xl px-0 py-2 w-full border border-gray-200 print:bg-white">
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm text-gray-500 tracking-normal text-center" style={{ margin: 0 }}>
            CO2e kg/kg
          </p>
          <p className="text-gray-800 text-lg mobile:text-base font-bold mt-0 text-center" style={{ margin: 0 }}>
            {co2ePerKg ? parseFloat(co2ePerKg).toFixed(2) : "N/A"}
          </p>
        </div>
        <div className="bg-gray-300 w-[1px] h-10 mx-1 rounded-full"></div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm text-gray-500 tracking-normal text-center" style={{ margin: 0 }}>
            Total CO2e kg
          </p>
          <p className="text-gray-800 text-lg mobile:text-base font-bold mt-0 text-center" style={{ margin: 0 }}>
            {typeof co2eTotal === 'number' ? co2eTotal.toFixed(2) : co2eTotal}
          </p>
        </div>
      </div>
    );
  } catch (error) {
    return (
      <div className="flex justify-center items-center bg-white border border-gray-200 rounded-full p-5 my-4 w-full mx-auto">
        <p></p>
      </div>
    );
  }
};

export default ShowClimateFootprintInKg;
